import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root',
})
export class SaleService {
  public mtds: Methods = new Methods();
  public url: string;
  public urlUser: string;
  public token;
  public headers: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
   
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    // Inicializar el token
    this.updateToken();
  }

  private createParams(data: any, token:any = ''): any {
    const json = JSON.stringify(data);
    return `json=${json}&authorization=${token}`;
  }

  private createHeaders(token: any): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': token
    });
  }

  updateToken(): void {
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
  }

  generateReportSO(js: { id: string; so: number; donwload: boolean; orientation: boolean; optionComments: boolean; 
                          optionLogo: boolean; optionCodes: boolean; optionSO: boolean; optionQTY: boolean; optionItemQTY: boolean; 
                          summary: boolean; optionItemsComments: boolean; optionItemsDescription: boolean; optionExtendedDescription: boolean; 
                          optionCategory: boolean; optionSerialNumber: boolean; optionPONumber: boolean; optionShippingCost: boolean;
                           optionServiceCharge: boolean; optionInstallationCost: boolean; optionMiscCharge: boolean; optionTax: boolean; 
                           optionDescription: boolean; optionLineCost: boolean; optionCurrencyCode: boolean; 
                           optionCurrencySymbol: boolean; }): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post(
      `https://itaderp.com/luisha/SalesOrder/SalesOrder.php`,js, {
        headers: headers,
         responseType: 'blob' ,
      }
    ).pipe(
      map((res: any) => res)
    );                        

  }

  generateReportPackingList(js: { id: string; so: number; donwload: boolean; orientation: boolean; optionLogo: boolean; optionInfo: boolean; 
                                  optionTrackingInfo: boolean; optionCustomerPO: boolean; optionSORep: boolean; optionTerms: boolean; 
                                  optionFromSoldTo: boolean; summary: boolean; optionDescription: boolean; shipment: any; 
                                  optionComments: boolean; optionClei: boolean; optionCategory: boolean;optionItemDescription: boolean;
                                  optionItemExtendedDescription:boolean; optionCondition: boolean; optionSoLineComments: boolean;
                                  bulkItems: any}): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post(
      `https://itaderp.com/ernestoha/PackingList/PackingList.php`,js, {
        headers: headers,
         responseType: 'blob' ,
      }
    ).pipe(
      map((res: any) => res)
    );                        

  }

  generateReportCommercialInvoice(js: { id: string; so: number; po: any; currency: string; shipper: string; consignee: string; 
                                  countryOfOrigin: string; donwload: boolean; orientation: boolean; optionLogo: boolean; optionInfo: boolean; 
                                  optionTotalQty: boolean; optionDescription: boolean; optionNameSection: boolean; optionDateSection: boolean; 
                                  optionDate: boolean; optionPO: boolean; optionSO: boolean; summary: any; optionCategory: boolean; 
                                  optionItemDescription: boolean; optionSerialNumber: boolean;optionCurrencyCode: boolean;
                                  optionCurrencySymbol:boolean; optionCurrencyMessage: boolean; optionComments: boolean; shipperExists: boolean;
                                  consigneeExists: boolean; bulkItems: any}): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post(
      `https://itaderp.com/ernestoha/CommercialInvoice/CommercialInvoice.php`,js, {
        headers: headers,
         responseType: 'blob' ,
      }
    ).pipe(
      map((res: any) => res)
    );                        

  }

  reportSaleOrderEmail(js: { id: string; so: number; donwload: boolean; orientation: boolean; optionComments: boolean; 
                          optionLogo: boolean; optionCodes: boolean; optionSO: boolean; optionQTY: boolean; optionItemQTY: boolean; 
                          summary: boolean; optionItemsComments: boolean; optionItemsDescription: boolean; optionExtendedDescription: boolean; 
                          optionCategory: boolean; optionSerialNumber: boolean; optionPONumber: boolean; optionShippingCost: boolean;
                           optionServiceCharge: boolean; optionInstallationCost: boolean; optionMiscCharge: boolean; optionTax: boolean; 
                           optionDescription: boolean; optionLineCost: boolean; optionCurrencyCode: boolean; 
                           optionCurrencySymbol: boolean; }): Observable<any>{
  let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post(
      `https://itaderp.com/emailso/SOEmail.php`,js, {
        headers: headers,         
      }
    ).pipe(
      map((res: any) => res)
    );
 }

  updateSaleOrderSettings(token: any, json: any, type: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    });
  
    const params = new HttpParams()
      .set('authorization', token)
      .set('type', type);
  
    return this._http.post(
      `${this.url}/soinfo/sale_order_settings`,
      json,
      {headers: headers,
        params: params
      }
    ).pipe(
      map((res: any) => res)
    );
  }

  updatePackingListSettings(token: any, json: any, type: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    });
  
    const params = new HttpParams()
      .set('authorization', token)
      .set('type', type);
  
    return this._http.post(
      `${this.url}/soinfo/packing_list_settings`,
      json,
      {headers: headers,
        params: params
      }
    ).pipe(
      map((res: any) => res)
    );
  }

  updateCommercialInvoiceSettings(token: any, json: any, type: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    });
  
    const params = new HttpParams()
      .set('authorization', token)
      .set('type', type);
  
    return this._http.post(
      `${this.url}/soinfo/commercial_invoice_settings`,
      json,
      {headers: headers,
        params: params
      }
    ).pipe(
      map((res: any) => res)
    );
  }

  doVoid(so_id): Observable<any> {
    return this.petition(`${this.url}/soinfo/dovoid/${so_id}`);
  }

  getDefaultLocation(): Observable<any> {
    return this.petition(`${this.url}/user/locationdefault`);
  }

  aplicarTax(so_id, json): Observable<any> {
    return this.petition(`${this.url}/soinfo/addtaxes/${so_id}`, json);
  }

  editgroupline(so_id, json): Observable<any> {
    return this.petition(`${this.url}/soinfo/groupdetail/edit/${so_id}`, json);
  }


  clearTax(so_id): Observable<any> {
    return this.petition(`${this.url}/soinfo/removetaxes/${so_id}`);
  }

  getLines(json): Observable<any> {
    return this.petition(`${this.url}/inventory/searchpartnumber`, json);
  }

  reserveGroups(json): Observable<any> {
    return this.petition(`${this.url}/inventory/searchpartnumberbygroup`, json);
  }

  updateDescriptionItem(id, json): Observable<any> {
    return this.petition(`${this.url}/inventory/editdesc/${id}`, json);
  }

  getStock(json): Observable<any> {
    return this.petition(`${this.url}/inventory/getstock`, json);
  }

  shipStatus(so_id, json): Observable<any> {
    return this.petition(`${this.url}/soinfo/setshipstatus/${so_id}`, json);
  }

  setClearTax(so_id, json): Observable<any> {
    return this.petition(`${this.url}/soinfo/setcleartax/${so_id}`, json);
  }

  setTaxConfig(so_id, json): Observable<any> {
    return this.petition(`${this.url}/soinfo/settaxconfig/${so_id}`, json);
  }


  searchPart(search, bulk: any, showNonInventory = 0): Observable<any> {
    let json;
    json = {
      busqueda: search,
      type: 'FOR-SO',
      bulk,
      showNonInventory
    };

    console.log(json);

    return this.petition(`${this.url}/inventory/searchpartnumberbymfgr`, json);
  }

  searchSO(search): Observable<any> {
    return this.petition(`${this.url}/soinfo/search/${search}`);
  }

  reserveItems(json): Observable<any> {
    return this.petition(`${this.url}/inventory/reservebulk`, json);
  }

  unreserveItems(json, type): Observable<any> {
    switch (type) {
      case 'history':
        return this.petition(`${this.url}/inventory_history/unreservebulk`, json);
      default:
        return this.petition(`${this.url}/inventory/unreservebulk`, json);
    }
  }

  unreserveAll(so_id): Observable<any> {
    return this.petition(`${this.url}/inventory/unreserveall/${so_id}`);
  }

  unreserveAllHistory(so_id): Observable<any> {
    return this.petition(`${this.url}/inventory_history/unreserveall/${so_id}`);
  }

  addLineItems(json): Observable<any> {
    return this.petition(`${this.url}/soinfo/additems`, json);
  }

  editLineItem(json): Observable<any> {
    return this.petition(`${this.url}/inventory/updatevaluegroupline`, json);
  }

   removegroupline(json): Observable<any> {
    return this.petition(`${this.url}/soinfo/removegroupline`, json);
  }

  deleteLineItem(id): Observable<any> {
    return this.petition(`${this.url}/inventory/removegroupitem/${id}`);
  }

  save(json): Observable<any> {
    if (json.id === null) {
      return this.createSO(json);
    } else {
      return this.editSO(json.id, json);
    }
  }

  createSO(json): Observable<any> {
    return this.petition(`${this.url}/soinfo/getnew`, json);
  }

  showLine(id: any, history = ''): Observable<any> {
    console.log("sale service history history => ", history);
    let url = '';
    if(history == 'inventory')
      url = `${this.url}/inventory/detail/${id}`;
    else if(history == 'inventory_history')
      url = `${this.url}/inventory_history/detail/${id}`;
    else if(history == 'group')
      url = `${this.url}/soinfo/groupdetail/${id}`;
    return this.petition(url);
  }

  changeconditiongroup(group_id, json): Observable<any> {
    return this.petition(`${this.url}/soinfo/changeconditiongroup/${group_id}`, json);
  }

  getOneSO(id): Observable<any> {
    return this.petition(`${this.url}/soinfo/detail/${id}`);
  }

  getOneSOBySO(id): Observable<any> {
    return this.petition(`${this.url}/soinfo/detailbyso/${id}`);
  }

  getOnePO(id): Observable<any> {
    return this.petition(`${this.url}/poinfo/detail/${id}`);
  }

  getLineItems(id): Observable<any> {
    return this.petition(`${this.url}/soinfo/solineitems/${id}`);
  }

  getLineItemsDesglosado(id, paginado: any, json: any = []): Observable<any> {
    return this.petition(`${this.url}/soinfo/solineitems_desglosado/${id}${paginado}`, json);
}

  availableToShip(id, paginado: any): Observable<any> {
    return this.petition(`${this.url}/soinfo/available_to_ship/${id}${paginado}`);
  }


  fixLine(so): Observable<any> {
    return this.petition(`https://www.itaderp.com/backend/bot-extraer-pos/bot-fix-group_items-so.php?so=${so}`);
  }

  getAllSO(): Observable<any> {
    return this.petition(`${this.url}/soinfo/list`);
  }

  earlyInvocie(so_id): Observable<any> {
    return this.petition(`${this.url}/soinfo/earlyinvoice/${so_id}`);
  }

  showAll(page, perPage, busqueda = null, status: string = 'ALL', sort = '', sortby = '', filtros = []): Observable<any> {
    let json = null;
    if (busqueda !== null && busqueda !== '') {
      json = {
        busqueda: busqueda,
      };
    }

    let url = `${this.url}/soinfo/listbystatus/${status}?page=${page}&perpage=${perPage}`;
    if (sortby) {
      if (sort === '') {
        sort = 'DESC';
      }
      url = url + '&order=' + sort + '&orderby=' + filtros[sortby].key;
    }

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + '&' + filtro.key + '=' + filtro.value;

        if (filtro.type) {
          url = url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }
    return this.petition(url, json);
  }

  showAllS(page, perPage, busqueda = null, status: string = 'ALL', sort = '', sortby = '', filtros = [],task:any,
  order:any,statusso:any,shipstatus:any): Observable<any> {
    interface Payload {
      sort: any;
      order: any;
      busqueda?: string;
      statusso: string;
      shipstatus: string;
    }
    let json: Payload = {
      sort: [task],
      order: order,
      shipstatus: statusso,
      statusso: shipstatus
    };
    if (busqueda !== null && busqueda !== '') {
      json.busqueda =  busqueda.trim();
     
    }

    let url = `${this.url}/soinfo/listbystatus/${status}?page=${page}&perpage=${perPage}`;
    if (sortby) {
      if (sort === '') {
        sort = 'DESC';
      }
      url = url + '&order=' + sort + '&orderby=' + filtros[sortby].key;
    }

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + '&' + filtro.key + '=' + filtro.value;

        if (filtro.type) {
          url = url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }
    return this.petition(url, json);
  }

  deleteSO(id): Observable<any> {
    return this.petition(`${this.url}/soinfo/remove/${id}`);
  }

  editSO(id, json): Observable<any> {
    return this.petition(`${this.url}/soinfo/edit/${id}`, json);
  }

  editvalue(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/soinfo/editvalue/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  getItemsNotShipped(id): Observable<any> {
    return this.petition(`${this.url}/soinfo/itemsnotshipped/${id}`);
  }

  listLite(): Observable<any> {
    return this.petition(`${this.url}/soinfo/listlite`);
  }

  petition(url, json = null, type = null) {
    this.updateToken();
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + `&json=${json}`;
    }

    if (type != null) {
      params = params + `&type=${type}`;
    }

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => {
        /*if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }*/
        return res;
      })
    );
  }
}
